import React, { Component } from 'react';
import HeaderNav from './headerNav'
import HeaderSelection from './headerSelection'
import stickybits from 'stickybits'

import { Checkbox } from 'material-ui';
import RadioButtonChecked from 'material-ui/svg-icons/toggle/radio-button-checked';
import RadioButtonUnchecked from 'material-ui/svg-icons/toggle/radio-button-unchecked';

class header extends Component {
  componentDidMount() {
    if (!this.props.mobile) {
      // add pollyfill to keep 'position: sticky;' style in Internet Explorer
      stickybits('.second-header', { useStickyClasses: true });
    }
  }

  handleNavigationResets = () => {
    if (!this.props.mobile) {
      // remove .js-is-sticky class & reset scroll
      document.querySelector('.second-header').classList.remove('js-is-sticky');
      window.scrollTo(window.scrollX, 0);
    }
  }

  render() {
    const { step, mobile } = this.props

    // only from the first step
    const { promos, offer, travel, langPlace } = this.props

    return (
      <div className="row second-header">
        <div className="stepper-container">
          <div className="wrap-container">
            <div className="container">
              <div className="flex-row">
                <HeaderNav step={step} handleNavigationResets={this.handleNavigationResets}/>
                <HeaderSelection />
              </div>
            </div>
          </div>
        </div>

        <div className="search-offers-container">
          <div className="container">
            {(promos && travel === 0)?
              <div className="row search-offers">
                <div className="container">
                  <div className="flex-row ">

                    <div className='col-md-12 col-sm-12 col-xs-12'>
                      <div className='row'>
                        <div className="title"><p>{langPlace.promotitle}</p></div>
                        <div style={{display: 'flex'}}>
                          {
                            promos.map((promo, index) => (
                              <Checkbox
                                className='promoCheckbox'
                                key={index}
                                style={{ width: 'auto' }}
                                labelStyle={{fontSize: 20, fontWeight: (offer === promo)? 900: 400}}
                                checkedIcon={<RadioButtonChecked/>}
                                uncheckedIcon={<RadioButtonUnchecked/>}
                                checked={offer === promo}
                                onCheck={() => this.props.onCheck(promo)}
                                label={langPlace.promos[promo]}
                              />
                            ))
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            : undefined}
          </div>
        </div>
      </div>
    );
  }
}

export default header;



// WEBPACK FOOTER //
// ./src/shared/routes/components/secondHeader.js